
import vue from 'vue'
import {
initWxJSSDK,
getDefaultAddress,
getAllNearTerminalList
} from "@/common/js/api.js";
import { getCookie,setCookie } from "@/common/js/utils";
import { bannerList } from "@/common/js/config";
import XHeader from 'vux/src/components/x-header/index.vue'
import Box from 'vux/src/components/box/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import Group from 'vux/src/components/group/index.vue'
import CellBox from 'vux/src/components/cell-box/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import Scroller from 'vux/src/components/scroller/index.vue'
import Icon from 'vux/src/components/icon/index.vue'
import VChart from 'vux/src/components/v-chart/v-chart.vue'
import VTooltip from 'vux/src/components/v-chart/v-tooltip.vue'
import VLine from 'vux/src/components/v-chart/v-line.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import VScale from 'vux/src/components/v-chart/v-scale.vue'
import Selector from 'vux/src/components/selector/index.vue'
import Divider from 'vux/src/components/divider/index.vue'
import Swiper from 'vux/src/components/swiper/swiper.vue'
import SwiperItem from 'vux/src/components/swiper/swiper-item.vue'
import Tabbar from 'vux/src/components/tabbar/tabbar.vue'
import TabbarItem from 'vux/src/components/tabbar/tabbar-item.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'

import { wxORzfb } from '../../../common/js/config';

export default {
components: {
XHeader,
Box,
XButton,
XInput,
Group,
CellBox,
Cell,
Scroller,
Icon,
VChart,
VTooltip,
VLine,
Flexbox,
FlexboxItem,
VScale,
Selector,
Divider,
Swiper,
SwiperItem,
Tabbar,
TabbarItem
},
methods: {
jumpAction(v) {
let self = this;
if( self.activityId!=null && self.activityId!='' ){
v+= "?activityId="+self.activityId;
}
this.$router.push({ path: "/"+v });
},
haveNotOpen() {
this.$router.push({ path: "/HaveNotOpen" });
},








getLocation() {
this.initLocation()
},
initLocation() {
let self = this
self.$wechat.getLocation({
type: 'gcj02', // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
fail: function(res) {
console.error(res)
self.listShow = true
},
success: function(res) {
var latitude = res.latitude 
var longitude = res.longitude 
var speed = res.speed 
var accuracy = res.accuracy 
setCookie('latitude', latitude)
setCookie('longitude', longitude)
self.myLocation = { latitude: latitude, longitude: longitude }
self.getAllNearTerminalList();
}
})
},
initZfbLocation() {
const self = this
ap.getLocation(function(res) {
var latitude = res.latitude 
var longitude = res.longitude 
var speed = res.speed 
var accuracy = res.accuracy 
setCookie('latitude', latitude)
setCookie('longitude', longitude)
self.myLocation = { latitude: latitude, longitude: longitude }
self.getAllNearTerminalList();
});
},
getAllNearTerminalList() {
let self = this
self.pageInfo.longitude = self.myLocation.longitude
self.pageInfo.latitude = self.myLocation.latitude
getAllNearTerminalList({data:self.pageInfo}).then(function(data) {
let content = data.Content
for (var i = 0; i < content.length; i++) {

let mile = content[i].juli;
content[i].juli = mile<1? parseFloat(mile * 1000).toFixed(2) + "m":mile+"km";
if (content[i].boxType == 2) {
let store = content[i].boxStoreInfo.split(",");
let specification = content[i].boxSpecification.split(",");
let terminalSource = [];
for (var j = 0; j < store.length; j++) {
const terminalSourceList = {
store:store[j].split(":")[1],
specification:specification[j].split(":")[1]
}
terminalSource.push(terminalSourceList)
}
content[i].terminalSource = terminalSource
self.list.push(content[i])
}
}
self.listShow = true
setTimeout(self.init, 500)
})
},
isAliOrWx() {

let typeBower = '';
let browser = {
versions: function() {
let u = navigator.userAgent,
app = navigator.appVersion;
return { //移动终端浏览器版本信息
trident: u.indexOf('Trident') > -1, //IE内核
presto: u.indexOf('Presto') > -1, //opera内核
webKit: u.indexOf('AppleWebKit') > -1, //苹果、谷歌内核
gecko: u.indexOf('Gecko') > -1 && u.indexOf('KHTML') == -1, //火狐内核
mobile: !!u.match(/AppleWebKit.*Mobile.*/), //是否为移动终端
ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //ios终端
android: u.indexOf('Android') > -1 || u.indexOf('Linux') > -1, //android终端或uc浏览器
iPhone: u.indexOf('iPhone') > -1, //是否为iPhone或者QQHD浏览器
iPad: u.indexOf('iPad') > -1, //是否iPad
webApp: u.indexOf('Safari') == -1 
};
}(),
language: (navigator.browserLanguage || navigator.language).toLowerCase()
};
if(browser.versions.mobile) { //判断是否是移动设备打开。browser代码在下面

var ua = navigator.userAgent.toLowerCase(); 
if(ua.match(/Alipay/i)=="alipay"){
typeBower = 'ali';
}
if(ua.match(/MicroMessenger/i) == "micromessenger") {
typeBower = 'wx';
}
}
return typeBower;
},
loginJump(redirect){
let self = this;
var authorizer_appid = getCookie('authorizer_appid') ? getCookie('authorizer_appid') : '';

setCookie( 'redirect', redirect );
if( redirect.indexOf('yueIndex') > -1 || redirect.indexOf('birdindex') > -1 ){
setCookie( 'yueBirdredirect', redirect );
}
if( redirect.indexOf('/#/yueIndex') > -1 ){
setCookie( 'yueredirect', redirect );
}

if(self.isAliOrWx() == 'wx' ){

window.location.href = window.location.origin + '/api/app/thirdPlatform/wxAuthLogin' + (authorizer_appid ? '?authorizer_appid=' + authorizer_appid : '');
} else if(self.isAliOrWx() == 'ali'){

window.location.href = window.location.origin + '/api/app/alipayThirdPlatform/AuthLogin' + (authorizer_appid ? '?authorizer_appid=' + authorizer_appid : '');
}
}
},
data() {
return {
list:[],
userInfo:{},
activityId: this.$route.query.activityId,
bannerList: bannerList,
title: "越秀城管局回收主页",
pageInfo: {
pageIndex: 1,
pageSize: 1
},
earthNewsList:[],
loaded: false,
myLocation:null,
listShow: false,
};
},
mounted() {

},
created() {
let self = this;
var redirect = location.href;

if( self.isAliOrWx() == 'ali' && redirect.indexOf('zfb.') < 0 ){

window.location.href = redirect.replace(/(qr\.)|(wx\.)/, "zfb.");
return ;
}else if( self.isAliOrWx() == 'wx' && redirect.indexOf('wx.') < 0 ){

window.location.href = redirect.replace(/(qr\.)|(zfb\.)/, "wx.");
return ;
}


let user = getCookie("user");
if (!user) {
self.loginJump(redirect);
return ;
}

var longitude = getCookie('longitude')
var latitude = getCookie('latitude')

if( self.activityId != null && self.activityId != '' ){
setCookie( 'activityId', self.activityId );
}
if(wxORzfb == 'wx') {
initWxJSSDK()
vue.wechat.ready(function(res) {
self.initLocation()
})
} else if(wxORzfb == 'zfb') {
self.initZfbLocation()
}
}
};



// WEBPACK FOOTER //
// ./src/components/activity/yuexiu/index.vue